import Swal from "sweetalert2";
import {log} from "@/state/pinia/log";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";



export const productsHelperMethods = {

    refreshLocalProductsList(rowActions,drugstoresLocalProductsVisibleHeadersTitlesMap,productsVisibleHeaders,currentPage,sortingKey,sortingDirection,searchRequest,showOnlyUnBound,boundWithCentralGuid) {
        const commonAppModule = useCommonAppModule()
        const lazyloader = useLazyLoaderModule()

        lazyloader.setDisplayLazyLoader(true);
        lazyloader.setProgressBarMessage("Pobieranie listy lokalnych towarów aptek.");
        commonAppModule.setRawDrugstoresProductsData([]);
        

        var availableHeaders = JSON.parse(JSON.stringify(commonAppModule.getRawDrugstoresProductsHeaders )).filter(header => productsVisibleHeaders.includes(header.key));

        var searchAndFilterRequest = {
            fields: null,
            search: searchRequest,
            filters: null
        }

        var payload = {
            searchAndFilterRequest: searchAndFilterRequest,
            currentPage: currentPage,
            sortingDirection: sortingDirection,
            sortingKey: sortingKey,
            showOnlyUnBound: showOnlyUnBound,
            boundWithCentralGuid: boundWithCentralGuid

        };

        return commonAppModule.httpGetRawDrugstoresProductsDataPaging(payload).then(() => {

            var localProductsRows = [];
            var products = JSON.parse(JSON.stringify(commonAppModule.getRawDrugstoresProductsData));
            for (var i = 0; i < products.length; i++) {


                products[i]["tooltip"] = commonAppModule.getDrugstoresNameMap[products[i]["id_apteki"]];
                products[i]["nazwa_apteki"] = commonAppModule.getDrugstoresNameMap[products[i]["id_apteki"]];
                if (products[i]["id_kartoteki_centralnej_towaru"] != null) {
                    products[i]["nazwa_kartoteki_centralnej_towaru"] = "[" + products[i]["id_kartoteki_centralnej_towaru"] + "] " + products[i]["nazwa_kartoteki_centralnej_towaru"];
                }
                localProductsRows.push(products[i]);
            }

            var localProductHeaders = []


            for (var j = 0; j < productsVisibleHeaders.length; j++) {
                var header = availableHeaders.find(header => header.key === productsVisibleHeaders[j]);
                if (header !== undefined) {
                    header["text"] = drugstoresLocalProductsVisibleHeadersTitlesMap[productsVisibleHeaders[j]];
                    // setting type on data_row_id and id_apteki column to number style
                    if (header.key === "data_row_id" || header.key === "id_apteki" || header.key === "bloz") {
                        header["class"] = "sticky-header col-number";
                    } else if (header.key === "nazwa_kartoteki_centralnej_towaru") {
                        header["sortable"] = false;
                    }

                    localProductHeaders.push(header);
                }
            }

            localProductHeaders.push(
                {
                    text: "Akcje",
                    key: "actions",
                    type: "actions",
                    style: "cursor:pointer;",
                    actions: rowActions

                }
            );

            // adding row actions
            for (var k = 0; k < localProductsRows.length; k++) {
                const bindButtonsClass = productsHelperMethods.getBindCentralProductActionClass(localProductsRows[k]);
                localProductsRows[k]["actions"] = [
                    {
                        text: "Usuń powiązanie",
                        icon: "fas fa-times",
                        action: "remove-central-product-binding",
                        class: productsHelperMethods.getUnbindCentralProductActionClass(localProductsRows[k]),
                        enabled: true,
                        tooltip: "Usuń powiązanie z centralnym towarem",
                    },
                    {
                        text: "",
                        icon: "fas fa-link",
                        action: "bind-with-central-product",
                        class: bindButtonsClass,
                        enabled: true,
                        tooltip: "Powiąż z centralnym towarem",
                    },
                    {
                        text: "",
                        icon: "fas fa-sync-alt",
                        action: "create-bind-with-central-product",
                        class: bindButtonsClass,
                        enabled: true,
                        tooltip: "Powiąż automatycznie",
                    },
                ];

            }

            var resultPayload = {
                availableHeaders: availableHeaders,
                localProductsRows: localProductsRows,
                localProductHeaders: localProductHeaders
            }

            return new Promise((resolve) => {
                resolve(resultPayload);
            });


        });
    },
    showBindWithCentralProductModal(items, rowIdentifierKey, localProductsRows) {
        var boundItems = 0
        for (var i = 0; i < items.length; i++) {
            var rowIdentifier = items[i];
            var productsFound = localProductsRows.find(row => row[rowIdentifierKey] === rowIdentifier); // there should be always only one product for DATA_ROW_ID
            if (productsHelperMethods.isLocalProductBound(productsFound)) {
                boundItems++;
            }

        }
        var resultPayload = {
            showSelectCentralProductModal: false,
        }
        if (boundItems > 0) {
            return productsHelperMethods.showExistingBindingsWarningModal().then((result) => {
                if (result.isConfirmed) {
                    resultPayload.showSelectCentralProductModal = true;
                    return new Promise((resolve) => {
                        resolve(resultPayload);
                    });
                }else{
                    resultPayload.showSelectCentralProductModal = false;
                    return new Promise((resolve) => {
                        resolve(resultPayload);
                    });
                }
            });
        } else {
            resultPayload.showSelectCentralProductModal = true;
            return new Promise((resolve) => {
                resolve(resultPayload);
            });
        }
    },
    showExistingBindingsWarningModal(){
        return Swal.fire({
            title: "Istnieją powiązania dla niektórych towarami",
            text: "Pośród zaznaczonych towarami istnieją tacy, którzy mają już powiązanie z centralnymi kartotekami towarami. Czy na pewno chcesz powiązać tych towarami z inną kartoteka centralną?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Nie",
            confirmButtonText: "Tak",
            customClass: {
                container: "swal-highest"
            },
        });
    },

    refreshFieldsAvailableForSearch(availableHeaders,drugstoresLocalProductsVisibleHeadersTitlesMap) {
        const commonAppModule = useCommonAppModule()
        const lazyloader = useLazyLoaderModule()
        return commonAppModule.httpGetRawDrugstoresProductsSearchKeys().then(() => {
            var fieldsAvailableForSearch = [];
            var searchKeysFetched = JSON.parse(JSON.stringify(commonAppModule.getRawDrugstoresProductsSearchKeys));
            var tableColumnsAvailableForSearch = availableHeaders.filter(header => searchKeysFetched.includes(header.key) && header.type === "text");
            for (var i = 0; i < tableColumnsAvailableForSearch.length; i++) {

                fieldsAvailableForSearch.push({
                    name: drugstoresLocalProductsVisibleHeadersTitlesMap[tableColumnsAvailableForSearch[i].key],
                    key: tableColumnsAvailableForSearch[i].key
                });
            }
            var fieldsAvailableForSearchPayload = {
                fieldsAvailableForSearch: fieldsAvailableForSearch
            }

            return new Promise((resolve) => {
                resolve(fieldsAvailableForSearchPayload);
            });
        });



    },

    getUnbindCentralProductActionClass(row) {
        if (productsHelperMethods.isLocalProductBound(row)) {
            return "btn btn-warning btn-sm table-actions-button edit-button";
        } else {
            return "element-not-visible";
        }

    },

    isLocalProductBound(row) {
        var boundCentralSupplieName = row["nazwa_kartoteki_centralnej_towaru"]
        if (boundCentralSupplieName === null || boundCentralSupplieName === undefined || boundCentralSupplieName === "") {
            return false;
        } else {
            return true;
        }
    },

    getBindCentralProductActionClass(row) {
        if (productsHelperMethods.isLocalProductBound(row)) {
            return "element-not-visible";
        } else {
            return "btn btn-success btn-sm table-actions-button edit-button";
        }

    },


    autoBindProducts() {
        return Swal.fire({
            title: "Powiązywanie towarami",
            text: "Nastąpi próba powiązania, niepowiązanych dotychczas lokalnych kartotek towarami z centralnymi kartotekami towarami. Czy chcesz rozpocząć proces?",
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Nie",
            confirmButtonText: "Tak",
            customClass: {
                container: "swal-highest"
            },
        }).then((result) => {
            if (result.isConfirmed) {
                const commonAppModule = useCommonAppModule()
                const lazyloader = useLazyLoaderModule()
                lazyloader.setDisplayLazyLoader(true);
                lazyloader.setProgressBarMessage("Powiązywanie loklanych kartotek...");
                return commonAppModule.httpAutoBindLocalProducts();
            }else{
                return new Promise((resolve) => {
                    resolve({isConfirmed: false});
                });
            }
        });
    },
    bindWithProduct(localIdsSelected,rowIdentifierKey,currentSelectedLocalProductData,selectedCentralProductGuidToBind) {
        if (selectedCentralProductGuidToBind == null) {
            Swal.fire({
                title: "Brak centralnego towaru",
                text: "Nie wybrano centralnego towaru do powiązania.",
                icon: "info",
                confirmButtonText: "OK",
                customClass: {
                    container: "swal-highest"
                },
            });
            return new Promise((resolve) => {
                resolve({isConfirmed: false});
            });
        } else {
            const commonAppModule = useCommonAppModule()
            const lazyloader = useLazyLoaderModule()
            lazyloader.setDisplayLazyLoader(true);
            lazyloader.setProgressBarMessage("Powiązywanie loklanych kartotek...");

            var localIdsToBind = localIdsSelected;
            if (currentSelectedLocalProductData != null) {
                localIdsToBind = [currentSelectedLocalProductData[rowIdentifierKey]];
            }

            var payload = {
                localIds: localIdsToBind,
                centralProductGuid: selectedCentralProductGuidToBind
            }

            return commonAppModule.httpBindLocalProductsIds(payload)

        }


    },

    unBindCentralProduct(localIds, rowIdentifierKey, localProductsRows) {
        var productsSelected = localProductsRows.filter(row => localIds.includes(row[rowIdentifierKey]));
        var productsBound = productsSelected.filter(row => productsHelperMethods.isLocalProductBound(row));

        if (productsBound.length === 0) {
            Swal.fire({
                title: "Brak powiązań",
                text: "Nie odnaleziono powiązań dla zaznaczonych towarami.",
                icon: "info",
                confirmButtonText: "OK",
                customClass: {
                    container: "swal-highest"
                },
            });
            return new Promise((resolve) => {
                resolve({isConfirmed: false});
            });
        } else {

            return Swal.fire({
                title: "Usuwanie powiązania",
                text: "Czy na pewno chcesz usunąć powiązanie z centralnym towarem?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                cancelButtonText: "Nie",
                confirmButtonText: "Tak",
                customClass: {
                    container: "swal-highest"
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    const commonAppModule = useCommonAppModule()
                    const lazyloader = useLazyLoaderModule()
                    lazyloader.setDisplayLazyLoader(true);
                    lazyloader.setProgressBarMessage("Usuwanie powiązań loklanych kartotek...");
                    var payload = {
                        localIds: localIds,
                    }

                    return commonAppModule.httpUnbindLocalProductsIds(payload).then(() => {
                        return new Promise((resolve) => {
                            resolve({isConfirmed: true});
                        });

                    });
                } else {
                    return new Promise((resolve) => {
                        resolve({isConfirmed: false});
                    });
                }
            });
        }


    },

    createAndBindProducts(localIdsToBind) {
        return Swal.fire({
            title: "Powiązywanie automatyczne",
            text: "Nastąpi próba utworzenia i/lub powiązania, niepowiązanych dotychczas lokalnych kartotek towarami z centralnymi kartotekami towarami. Czy chcesz rozpocząć proces?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Nie",
            confirmButtonText: "Tak",
            customClass: {
                container: "swal-highest"
            },
        }).then((result) => {
            if (result.isConfirmed) {
                var payload = {
                    localIds: localIdsToBind,
                }
                log.log(payload);
                const commonAppModule = useCommonAppModule()
                const lazyloader = useLazyLoaderModule()
                lazyloader.setDisplayLazyLoader(true);
                lazyloader.setProgressBarMessage("Tworzenie i powiązywanie loklanych kartotek...");
                return commonAppModule.httpCreateOrBindLocalProductsIds(payload);

            } else {
                return new Promise((resolve) => {
                    resolve();
                });
            }
        });
    },

    showLocalProductDetails(localProductTableItem, rowIdentifierKey, localProductsRows) {
        var rowIdentifier = localProductTableItem[rowIdentifierKey];
        var productsFound = localProductsRows.find(row => row[rowIdentifierKey] === rowIdentifier); // there should be always only one product for DATA_ROW_ID
        var responsePayload = {
            productDetailsModalTitle: "Brak danych towaru ",
            showSelectCentralProductModal: false,
            currentSelectedLocalProductData: null
        }

        if (productsFound != null) {
            responsePayload.currentSelectedLocalProductData = JSON.parse(JSON.stringify(productsFound));
            if (responsePayload.currentSelectedLocalProductData["actions"] != null) {
                delete responsePayload.currentSelectedLocalProductData["actions"];
            }
            responsePayload.productDetailsModalTitle = "Dane towaru: " + productsFound["nazwa_towaru"];
            responsePayload.showLocalDrugstoresProductsModal = true;
            return new Promise((resolve) => {
                resolve(responsePayload);
            });

        } else {
            return productsHelperMethods.showNoProductDataWarning(rowIdentifier);
        }

    },

    bindWithCentralProduct(localProductTableItem, rowIdentifierKey, localProductsRows) {
        // open modal with central products list (one choice list)

        var rowIdentifier = localProductTableItem[rowIdentifierKey];
        var productsFound = localProductsRows.find(row => row[rowIdentifierKey] === rowIdentifier); // there should be always only one product for DATA_ROW_ID
        var responsePayload = {
            showSelectCentralProductModal: false,
            currentSelectedLocalProductData: null
        }
        if (productsFound != null) {

            if (productsHelperMethods.isLocalProductBound(productsFound)) {
                Swal.fire({
                    title: "Powiązanie już istnieje",
                    text: "Powiązanie tego towaru lokalnego z kartoteką centralną towaru już istnieje, czy na pewno chcesz powiązać tego towar z inną kartoteka centralną?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    cancelButtonText: "Nie",
                    confirmButtonText: "Tak",
                    customClass: {
                        container: "swal-highest"
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        responsePayload.showSelectCentralProductModal = true;
                        responsePayload.currentSelectedLocalProductData = JSON.parse(JSON.stringify(productsFound));
                        return new Promise((resolve) => {
                            resolve(responsePayload);
                        });
                    } else {
                        responsePayload.showSelectCentralProductModal = false;
                        responsePayload.currentSelectedLocalProductData = null;
                        return new Promise((resolve) => {
                            resolve(responsePayload);
                        });
                    }
                });
            } else {

                responsePayload.showSelectCentralProductModal = true;
                responsePayload.currentSelectedLocalProductData = JSON.parse(JSON.stringify(productsFound));
                return new Promise((resolve) => {
                    resolve(responsePayload);
                });
            }

        } else {
            responsePayload.showSelectCentralProductModal = false;
            responsePayload.currentSelectedLocalProductData = null;
            return new Promise((resolve) => {
                resolve(responsePayload);
            });
        }
    },

    showNoProductDataWarning(localProductTableItem) {
        return Swal.fire({
            title: "Brak towaru",
            text: "Nie odnaleziono towaru o ID lokalnym " + localProductTableItem,
            icon: "info",
            confirmButtonText: "OK",
            customClass: {
                container: "swal-highest"
            },
        });
    },


};
